import { ListItem } from './utility'
import { DataMap } from '@grapecity/wijmo.grid'

export function fromListToMap<T>(list: ListItem<T>[]): DataMap {
    return new DataMap(list, 'value', 'display')
}

export function fromMapToList<T>(map: DataMap, key1: string, key2: string): ListItem<T>[] {
    return map.collectionView.items.map(x => new ListItem(x[key1], x[key2]))
}

export function generateGuid(): string {
    // Generates a RFC4122 version 4 compliant GUID
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        const r = crypto.getRandomValues(new Uint8Array(1))[0] % 16
        const v = c === 'x' ? r : (r & 0x3) | 0x8
        return v.toString(16)
    })
}

export function getInitials(fullName: string): string {
    // Split the full name by spaces
    const nameParts = fullName.trim().split(' ')

    // Get the first initial from each part and convert them to uppercase
    if (nameParts.length < 2) {
        return nameParts[0].charAt(0).toUpperCase()
    } else {
        const firstInitial = nameParts[0].charAt(0).toUpperCase()
        const secondInitial = nameParts[1].charAt(0).toUpperCase()

        // Return the initials
        return firstInitial + secondInitial
    }
}
